export default {
      id: "help-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#help-usage",
      toString: function () {
        return this.url;
      }
    }